import { createAction, createReducer } from '@reduxjs/toolkit';
import { IApiType } from './interface/apiInterface';
import { IInitialState } from './interface/reduxInterface';

const INITIAL_STATE: IInitialState = {
  isActive: false,
  isLoading: false,
  gotSuccess: false,
  gotError: false,
  dateSearch: {
    start: '',
    end: '',
  },
  response: {
    status: false,
    path: '',
  },
};

export const getAnalyticReportCsvReportFromApi = createAction(
  '@accountingApp/GET_ANALYTICREPORTCSV_REPORT_FROM_API'
);
export const gotAnalyticReportCsvReportFromApi = createAction<any>(
  '@accountingApp/GOT_ANALYTICREPORTCSV_REPORT_FROM_API'
);
export const gotErrorFromAnalyticReportCsvReportApi = createAction(
  '@accountingApp/GOT_ERROR_FROM_ANALYTICREPORTCSV_REPORT_API'
);

const analyticReportCsvReducer = createReducer(INITIAL_STATE, {
  [getAnalyticReportCsvReportFromApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: true,
    gotSuccess: false,
    gotError: false,
  }),

  [gotErrorFromAnalyticReportCsvReportApi.type]: (state: any) => ({
    ...state,
    isActive: false,
    isLoading: false,
    gotSuccess: false,
    gotError: true,
  }),

  [gotAnalyticReportCsvReportFromApi.type]: (state, action: IApiType) => ({
    ...state,
    isActive: true,
    isLoading: false,
    gotSuccess: true,
    gotError: false,
    dateSearch: {
      start: action.payload.data_de_pesquisa.de,
      end: action.payload.data_de_pesquisa.ate,
    },
    response: {
      status: action.payload.status,
      path: action.payload.path,
    },
  }),
});

export default analyticReportCsvReducer;
